<template>
  <div class="cate-card-wrapper" :class="{'not-simple': type === 'notSimple'}" @click="cardClick">
    <div class="top-flex-box" :class="{'title-wrap': wrap.title}">
      <div
        class="img-box"
        data-width="305"
        v-lazy:background-image="{
          src: valuedata.headImg,
        }"
      >
        <p class="top-logo-box" v-if="type === 'simple' && valuedata.logoImg">
          <img 
            class="shop-logo-img" 
            v-lazy="valuedata.logoImg"
            data-width="72"
          />
        </p>
        <p
          class="efo-favourable-lable"
          v-if="valuedata.actLabel"
          v-text="valuedata.actLabel"
        ></p>
      </div>
      <p
        class="cate-name"
        ref="efocatetitle"
        v-text="valuedata.itemName"
      ></p>
    </div>
    <div class="footer-box" :class="{'box-wrap': wrap.btn}">
      <div class="price-box">
        <p class="price-act" v-text="valuedata.specialPriceDisplay"></p>
        <p class="price-ori" :class="{'text-indent': valuedata.specialPriceDisplay === valuedata.priceDisplay}" v-text="valuedata.priceDisplay"></p>
      </div>
      <div
        class="fast-buy-button"
        ref="fastbuybutton"
        v-text="$t('FoodC_dish_Purchase_NrCl')"
        @click.stop="buyBtnClick"
      ></div>
    </div>
    <div v-if="type === 'notSimple'" class="shop-info">
      <img
        v-if="valuedata.logoImg"
        class="shop-logo-img"
        :src="valuedata.logoImg"
        alt=""
      >
      <div class="shop-content-box">
        <p class="shop-name" v-text="valuedata.shopName"></p>
        <p class="other-box">
          <span class="delivery-time" v-text="valuedata.deliveryDesc"></span>
          <span class="space-spot" v-if="valuedata.shopFavorTip"></span>
          <span class="delivery-mode" v-if="valuedata.shopFavorTip"><RichText :text="valuedata.shopFavorTip"/></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import RichText from '@/components/RichText'

export default {
  name: 'EFOCateCard',
  components: {
    RichText
  },
  props: {
    type: {
      type: String,
      default: 'simple' // simple  notSimple
    },
    // 主动控制button折行
    wrap: {
      type: Object,
      default: () => {
        return {}
      }
    },
    valuedata: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    this.$nextTick(this.computedWrapStatus)
  },
  methods: {
    buyBtnClick() {
      this.$emit('buy-click', this.valuedata)
    },
    cardClick() {
      this.$emit('card-click', this.valuedata)
    },
    computedWrapStatus() {
      let domBtn = this.$refs.fastbuybutton
      let domTitle = this.$refs.efocatetitle
      let params = {btn: false, title: false}
      if (domBtn && domBtn.offsetWidth === domBtn.parentNode.offsetWidth) {
        params.btn = true
      }
      if (domTitle) {
        let lineHeight = window.getComputedStyle(domTitle, null)['line-height']
        lineHeight = +lineHeight.replace('px', '') + 2
        params.title = domTitle.offsetHeight > lineHeight
      }
      this.$emit('update-wrap', params)
    }
  }
}
</script>

<style lang="scss" scoped  src="./index.scss"></style>